import { Menu as NovaBaseMenu } from '@fme-nova/components'
import { default as MuiBaseMenu, MenuProps } from '@mui/material/Menu'

import { styled } from '../../theme'
import { createComponentWrapperWithRef, Z_INDEX } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

const MuiMenu: MsdkStyledComponent<MenuProps> = styled(MuiBaseMenu)`
  z-index: ${Z_INDEX.popover};
`

const NovaMenu: MsdkStyledComponent<MenuProps> = styled(NovaBaseMenu)`
  z-index: ${Z_INDEX.popover};

  .MuiDivider-root {
    margin: 8px 0;
  }
`

export const Menu = createComponentWrapperWithRef<MenuProps>(
  {
    mui: MuiMenu,
    nova: NovaMenu,
  },
  'Menu',
)
